import { returnReadableTime, getFigcaptionLabel, getFigcaptionTitle } from '../tools/helpers';
import { i18n } from '@/tools/i18n';
import { logger } from '../tools/logger';
import { actionTypes } from '../types';

export default {
	init() {
		[...this.$el.querySelectorAll('.post--audio')].forEach((post, index) => {
			logger.log('Audio init .post--audio: ', index);
			const $mediaId = post.querySelector('[media-id]');
			const mediaID = $mediaId ? $mediaId.getAttribute('media-id') : null;
			const isSynced = post.hasAttribute('synced');

			post.addEventListener('click', () => {
				logger.log('Audio .post--audio.clicked: ', mediaID);
				this.$store.dispatch(actionTypes.audioTogglePlay, { mediaID, isSynced });
			});

			// remove audio description text button if no text is avaible or initialise functionality
			const $altButton = post.querySelector('.element--button--alt');
			const $caption = post.querySelector('.element__caption__text--alt');
			if ($caption) $caption.setAttribute('tabindex', '-1');
			if (
				post.querySelector('.element__caption__text--alt') &&
				post.querySelector('.element__caption__text--alt').innerHTML === ''
			) {
				$altButton.remove();
			} else {
				if ($altButton) {
					post.setAttribute('show-alt', 'false'); // default should be set on markup-level
					$altButton.addEventListener('click', event => {
						event.stopPropagation();

						const container = document.querySelector('[is-current="true"]');
						const scrollY =
							this.$store.state.pageTransitionMode === 'simple' ? window.scrollY : container.scrollTop;

						post.setAttribute('show-alt', !(post.getAttribute('show-alt') === 'true'));
						$altButton.setAttribute(
							'aria-label',
							`${i18n.t('audiodescription')} ${
								post.getAttribute('show-alt') === 'true' ? i18n.t('opened') : i18n.t('closed')
							} `
						);
						post.setAttribute('aria-checked', 'true');
						if ($caption) {
							// restore y-scroll-position
							requestAnimationFrame(() => {
								$caption.focus();
								if (this.$store.state.pageTransitionMode === 'simple') {
									window.scrollTo(0, scrollY);
								} else {
									container.scrollTop = scrollY;
								}
							});
						}
					});
					$altButton.setAttribute('role', 'switch');
					post.setAttribute('aria-checked', 'false');
					$altButton.setAttribute('tabindex', 0);
					$altButton.setAttribute('aria-label', `${i18n.t('audiodescription')} ${i18n.t('closed')} `);
				}
			}

			if (post.querySelector('time')) {
				const time = post.querySelector('time').textContent;
				if (time) post.querySelector('time').textContent = returnReadableTime(parseFloat(time));
			}
			// use icon so if alternative text button is still selecteable
			post.removeAttribute('tabindex');
			const icon = post.querySelector('.element__icon');
			if (icon) {
				icon.setAttribute('role', 'button');
				icon.setAttribute('tabindex', 0);
				icon.setAttribute('aria-label', `${i18n.t('playAudio')} ${getFigcaptionTitle(post)}`);
			}
			// hide caption elements from screen reader
			[...post.querySelectorAll(' .element__caption__headline, .element__caption__time')].forEach(element =>
				element.setAttribute('aria-hidden', true)
			);
		});

		this.activeMediaUnwatch = this.$store.watch(
			() => this.$store.getters.activeMediaID,
			(newID, oldID) => {
				this.$el.querySelectorAll(`.element--audio[media-id="${newID}"]`).forEach(el => {
					el.setAttribute('media-active', true);

					el.parentElement.parentElement.setAttribute('element-active', true);
					const icon = el.querySelector('.element__icon');
					icon.setAttribute(
						'aria-label',
						`${i18n.t('stopAudio')} ${getFigcaptionLabel(el.parentNode.parentNode)}`
					);
				});
				this.$el.querySelectorAll(`.element--audio[media-id="${oldID}"]`).forEach(el => {
					el.setAttribute('media-active', false);
					el.parentElement.parentElement.setAttribute('element-active', false);
					const icon = el.querySelector('.element__icon');
					icon.setAttribute(
						'aria-label',
						`${i18n.t('playAudio')} ${getFigcaptionTitle(el.parentNode.parentNode)}`
					);
				});
			}
		);
	},
	destroy() {
		if (this.activeMediaUnwatch) {
			this.activeMediaUnwatch();
		}
	},
};
